"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrBrandLogos = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const fdr_brand_logo_1 = require("./fdr-brand-logo");
const BrandLogosWrap = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    width: ['100%', 'auto'],
    borderBottom: ['1px solid', 'none'],
    borderColor: 'borderColor',
    lineHeight: ['1', 'inherit'],
    alignItems: 'center',
    justifyContent: ['center', 'space-between'],
}), ({ theme }) => theme.brandLogos.items);
const FdrBrandLogos = ({ brandLogos, className, }) => {
    return (react_1.default.createElement(BrandLogosWrap, { className: className }, brandLogos.map((item, index) => (react_1.default.createElement(fdr_brand_logo_1.FdrBrandLogo, { item: item, key: index })))));
};
exports.FdrBrandLogos = FdrBrandLogos;
//# sourceMappingURL=fdr-brand-logos.js.map